import * as S from './styles'
import { Controller, useForm } from "react-hook-form"
import { FooterWithButtons } from "../../components/FooterWithButtons"
import { Input, Inputs } from "components/Input"
import { IMaskInput } from "react-imask"
import { NewInput } from "components/NewInput"
import { RadioButton } from "components/RadioButton"
import { t } from 'i18next'
import { usePersonalInfoSchema } from 'pages/Checkin/schemas/PersonalInfo'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useNavigate } from 'react-router'
import { useSessionStorage } from 'context/sessionStorage'
import { useEffect, useState } from 'react'
import fetchAxios from 'services/http'
import useAlert from 'components/Notification'

interface AddAccompanyingProps {
    birthDate: string;
    documentNumber: string
    documentType: string;
    email: string;
    name: string;
    phone: string;
    surname: string;

}

export const AddAccompanying = () => {

    const { omitCountryYouLive } = usePersonalInfoSchema();

    const [otherAccompanying, setOtherAccompanying] = useState<AddAccompanyingProps[]>([])

    type FormData = z.infer<typeof omitCountryYouLive>;

    const { Alert, showAlert } = useAlert({ active: false, title: '', type: "SUCCESS" })

    const navigate = useNavigate();

    const pathnameActual: string = window.location.pathname.endsWith('/') ? window.location.pathname.slice(0, -1) : window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'));

    const { saveToSessionStorage, getFromSessionStorage } = useSessionStorage()

    const { handleSubmit, formState: { errors }, control, trigger, watch, setValue } = useForm<FormData>({
        resolver: zodResolver(omitCountryYouLive),
        defaultValues: {
            documentType: 'CPF'
        }
    });

    const formatDate = (date: string) => {
        // Divide a data em partes usando "-" como separador
        const parts = date.split('-');
        // Reorganiza as partes. Como `split` retorna [ano, mês, dia], reorganizamos para [dia, mês, ano]
        const formattedDate = `${parts[2]}${parts[1]}${parts[0]}`;
        return formattedDate;
    }

    const cpfNumber = watch('documentNumber')

    useEffect(() => {
        if (cpfNumber && cpfNumber.length === 11) {
            const getInfoByCpf = async () => {
                try {
                    const { data, status } = await fetchAxios.get(`checkin/${cpfNumber}`)
                    if (data.code !== 404 && status === 200) {
                        setValue('name', data.owner.name)
                        setValue('surname', data.owner.surname)
                        setValue('birthDate', !!data.owner.date_of_birth ? formatDate(data.owner.date_of_birth) : '')
                        setValue('phone', data.owner.mobile_phone)
                        setValue('email', data.owner.email)
                    }
                } catch (error) {
                    console.error(error);
                }
            }
            getInfoByCpf()
        }
    }, [cpfNumber])

    useEffect(() => {
        const data = getFromSessionStorage('accompanying')

        if (data) {
            setOtherAccompanying(data)
        }
    }, [])


    const onSubmit = (data: FormData) => {
        const dataGuest = getFromSessionStorage('personal-info')
        const othersAccompanyigDocumentSame = otherAccompanying.filter((item) => item.documentNumber === data.documentNumber)
        const othersAccompanyigPhoneSame = otherAccompanying.filter((item) => item.phone.replace('+', '') === data?.phone?.replace('+', ''))
        const othersAccompanyigEmailSame = otherAccompanying.filter((item) => item.email === data.email)
        const guestAccompanyingDocumentSame = dataGuest.documentNumber === data.documentNumber
        const guestAccompanyingPhoneSame = dataGuest.phone.replace('+', '') === data?.phone?.replace('+', '')
        const guestAccompanyingEmailSame = dataGuest.email === data.email

        if (guestAccompanyingDocumentSame) {
            showAlert({ active: true, title: t('checkin.addAccompanying.errors.documentNumberEqualGuest'), type: "ERROR" })
        }
        else if (guestAccompanyingPhoneSame) {
            showAlert({ active: true, title: t('checkin.addAccompanying.errors.phoneEqualGuest'), type: "ERROR" })
        }
        else if (guestAccompanyingEmailSame) {
            showAlert({ active: true, title: t('checkin.addAccompanying.errors.emailEqualGuest'), type: "ERROR" })
        }
        else if (othersAccompanyigDocumentSame.length > 0) {
            showAlert({ active: true, title: t('checkin.addAccompanying.errors.documentNumberEqualAccompanying'), type: "ERROR" })
        }
        else if (othersAccompanyigPhoneSame.length > 0) {
            showAlert({ active: true, title: t('checkin.addAccompanying.errors.phoneEqualAccompanying'), type: "ERROR" })
        }
        else if (othersAccompanyigEmailSame.length > 0) {
            showAlert({ active: true, title: t('checkin.addAccompanying.errors.emailEqualAccompanying'), type: "ERROR" })
        }
        else {
            saveToSessionStorage('accompanying', [...otherAccompanying, data])
            navigate(`${pathnameActual}/accompanying`, { replace: true })
        }


    }

    const handleBackPage = () => {
        navigate(`${pathnameActual}/accompanying`)
    }

    return (
        <S.ContainerAddAccompanying>
            <h1>{t('checkin.addAccompanying.title')}</h1>
            <h5>{t('checkin.addAccompanying.subtitle')}</h5>
            <S.FormContainer>
                <S.ContainerRadio className="document" id="document">
                    <strong>{t('checkin.personalInformation.forms.label.typeDocument')}</strong>
                    <S.ContainerRadioButtons >
                        <Controller
                            name="documentType"
                            control={control}
                            render={({ field }) => (
                                // <Input width={"100%"} id="documentType" onBlur={() => trigger('documentType')} htmlFor="documentType" errorText={errors.documentType?.message} onChange={onChange} placeholder={''} title={t('checkin.personalInformation.forms.label.typeDocument')} value={value} />
                                <RadioButton {...field} control={control} label={t('checkin.personalInformation.forms.label.cpf')} value="CPF" />
                            )
                            }
                        />
                        <Controller
                            name="documentType"
                            control={control}
                            render={({ field }) => (
                                // <Input width={"100%"} id="documentType" onBlur={() => trigger('documentType')} htmlFor="documentType" errorText={errors.documentType?.message} onChange={onChange} placeholder={''} title={t('checkin.personalInformation.forms.label.typeDocument')} value={value} />
                                <RadioButton {...field} control={control} label={t('checkin.personalInformation.forms.label.passport')} value={'PASSPORT'} />
                            )
                            }
                        />
                    </S.ContainerRadioButtons>
                </S.ContainerRadio>
                {watch('documentType') === 'PASSPORT' ? (
                    <Controller
                        name="documentNumber"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Input width={"100%"} id="documentNumber" onBlur={() => trigger('documentNumber')} htmlFor="documentNumber" errorText={errors.documentNumber?.message} onChange={onChange} placeholder={''} title={t('checkin.personalInformation.forms.label.passport')} value={value} />
                        )
                        }
                    />
                ) : (
                    <Controller
                        name="documentNumber"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <NewInput mask={''} width={'100%'} name="documentNumber" htmlFor="documentNumber" placeholder="" title={t('checkin.personalInformation.forms.label.cpf')} type="text" errorText={errors.documentNumber?.message}>
                                <IMaskInput
                                    width={'100%'}
                                    mask={[{ mask: "000.000.000-00" }]}
                                    radix="."
                                    unmask={true} // true|false|'typed'
                                    value={value}
                                    onAccept={(value, mask) => {
                                        onChange(value)
                                    }}
                                    placeholder=""
                                    onBlur={() => trigger('documentNumber')}
                                />
                            </NewInput>
                        )
                        }
                    />
                )}
                <Controller
                    name="name"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <Input width={"100%"} id="name" onBlur={() => trigger('name')} htmlFor="name" errorText={errors.name?.message} onChange={onChange} placeholder={''} title={t('checkin.personalInformation.forms.label.name')} value={value} />
                    )
                    }
                />
                <Controller
                    name="surname"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <Input width={"100%"} id="surname" onBlur={() => trigger('surname')} htmlFor="surname" errorText={errors.surname?.message} onChange={onChange} placeholder={''} title={t('checkin.personalInformation.forms.label.surname')} value={value} />
                    )
                    }
                />
                <Controller
                    name="birthDate"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <NewInput width={'100%'} mask={''} id="birthDate" name="birthDate" htmlFor="birthDate" placeholder={t('checkin.personalInformation.forms.placeholder.birthDate')} title={t('checkin.personalInformation.forms.label.birthDate')} type="text" errorText={errors.birthDate?.message}>
                            <IMaskInput
                                mask={'**/**/****'}
                                radix="."
                                unmask={true} // true|false|'typed'
                                value={value}
                                onAccept={(value, mask) => {
                                    onChange(value)
                                }}
                                placeholder={t('checkin.personalInformation.forms.placeholder.birthDate')}
                                onBlur={() => trigger('birthDate')}
                            />
                        </NewInput>
                    )}
                />
                <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                        <Inputs.Phone
                            width={'100%'}
                            onChangePhoneNumber={field.onChange}
                            htmlFor={field.name}
                            placeholder=""
                            title={t('checkin.addAccompanying.phone')}
                            type=""
                            {...field}
                            value={field.value}
                            errorText={errors.phone?.message}
                            onBlur={() => {
                                trigger('phone')
                            }}
                        />
                    )}
                />
                <Controller
                    name="email"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <Input width={"100%"} id="email" onBlur={() => trigger('email')} htmlFor="email" errorText={errors.email?.message} onChange={onChange} placeholder={''} title={t('checkin.addAccompanying.email')} value={value} />
                    )
                    }
                />
            </S.FormContainer>
            <FooterWithButtons handleBackStep={handleBackPage} handleNextStep={handleSubmit(onSubmit)} nextButtonTitle={t('checkin.addAccompanying.buttonRegister')} />
            <Alert />
        </S.ContainerAddAccompanying>
    )
}